/**
 * Takes in an integer and returns it with it's ordinal suffix appended. (st, th, nd, rd)
 *
 * @param {Number} n
 * @returns {string}
 */
export const getOrdinalNumber = n =>
    n + (n > 0 ? ['th', 'st', 'nd', 'rd'][(n > 3 && n < 21) || n % 10 > 3 ? 0 : n % 10] : '');

/**
 * Takes a Number and converts it to pixels
 *
 * @param {Number} v
 * @returns {`${string}px`}
 */
export const px = v => `${v}px`;

/**
 * Waits until an element matching the provided selector is in the DOM.
 *
 * @param {string} selector
 * @returns {Promise<HTMLElement>}
 */
export const waitForElement = selector => {
    return new Promise(resolve => {
        if (document.querySelector(selector)) {
            return resolve(document.querySelector(selector));
        }

        const observer = new MutationObserver(() => {
            if (document.querySelector(selector)) {
                resolve(document.querySelector(selector));
                observer.disconnect();
            }
        });

        observer.observe(window.document.body, {
            childList: true,
            subtree: true,
        });
    });
}



// WEBPACK FOOTER //
// ./scripts/util/index.js